<template>
  <div id="pay">
    <head-Back title="VIP服务"></head-Back>
    <div class="titile">正在开通VIP会员</div>
    <div class="pay-back">您买的是安心、和平与尊重</div>
    <div class="pay-title">请选择你要购买的VIP：</div>
    <div class="pay-list">
      <div v-for="(vipInfo,index) in viplist" class="pay-list-dive">
        <div
          class="pay-simple"
          :class="{paySimpleunclick:vipInfo.active == true }"
          @click="chooseVip(vipInfo,index)"
        >
          <div v-if="vipInfo.isflag" class="pay-tui">推荐开通永久VIP</div>
          <span class="pay-simple-name">{{ vipInfo.name }}</span>
          <br />
          <span class="pay-simple-money">{{ vipInfo.price }}</span>
          <br />

          <i v-if="vipInfo.yprice != ''" class="pay-simple-i"></i>
          <span class="pay-simple-yuan">{{ vipInfo.yprice }}</span>
        </div>
      </div>
    </div>

    <div class="unpay-div">
      <div class="unpay-div-title">待支付金额</div>
      <div class="unpay-div-a-money">
        <span v-if=" yprice != '' ">{{ yprice }}元</span>
      </div>
      <div class="unpay-div-money">{{ price }}元</div>
    </div>

    <!--<div class="pay-agree">
      <label class="label pay-agree-span">
        <span>
          我已阅读并且同意
          <a>《VIP会员协议》</a>
        </span>
        <input type="checkbox" checked="checked" class="checkbox" />
        <span class="check-mark"></span>
      </label>
    </div>-->

    
    <!--苹果支付-->
    <div>
      <!--<div class="pay-ios">
        <div class="pay-ios-content">苹果支付</div>

       
        <div :class="weixinpayClass" @click="changeImg(99)"></div>
      </div>-->
      <div class="vip-button" @click="comnitPay">立即缴费</div>
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back";
import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import api from "../../api/index";
import tips from "@/estoast";

export default {
  metaInfo: {
    title: "VIP服务"
  },
  name: "pay",
  data() {
    return {
      msg: "VIP服务",
      weixinpayClass: "pay-checked",
      alipayClass: "pay-check",
      isIOS: false,
      iosPay: false,
      viplist: [
        {
          name: "永久VIP",
          yprice: 5940,
          price: 1298,
          isflag: true,
          active: true,
          type: 3
        },
        {
          name: "包年VIP",
          yprice: 1188,
          price: 898,
          isflag: false,
          active: false,
          type: 2
        },
        {
          name: "6个月VIP",
          yprice: "",
          price: 588,
          isflag: false,
          active: false,
          type: 5
        },
        {
          name: "3个月VIP",
          yprice: "",
          price: 298,
          isflag: false,
          active: false,
          type: 4
        },
        {
          name: "1个月VIP",
          yprice: "",
          price: 98,
          isflag: false,
          active: false,
          type: 1
        }
      ],
      yprice: 2298,
      price: 12222,
      type: 3,
      paymethod: 6
    };
  },

   beforeCreate() {
 
    var ua = navigator.userAgent;
    console.log("页面加载开始 ua:" + JSON.stringify(ua));
    if(ua.indexOf('(jsq)') > 0){
      console.log("页面加载开始 ua flag:" + true);
      store.commit(types.SET_MJB, "jsq");
    }else{
      store.commit(types.SET_MJB, "hyb");
    }

  },
  mounted: function() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");

    var token = this.getToken;
    console.log("store里面的toekn有值" + JSON.stringify(token));
    if (token == null || token == "") {
      token = localStorage.getItem("token");
      console.log("localStorage缓存token：" + token);
      store.commit(types.LOGIN, token);
    }
    if (token == "" || token == null) {
      this.$router.push("/login");
    }
    this.init();
    this.initPayMethod();
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList",
      "getAppFlag"
    ])
  },
  methods: {
    changeImg(num) {
      if (num == 5) {
        this.alipayClass = "pay-checked";
        this.weixinpayClass = "pay-check";
        this.paymethod = 5;
      } else if (num == 6) {
        this.weixinpayClass = "pay-checked";
        this.alipayClass = "pay-check";
        this.paymethod = 6;
      } else if (num == 99) {
        this.weixinpayClass = "pay-checked";
        this.alipayClass = "pay-check";
        this.paymethod = 99;
      } else {
        tips.toast("请选择正确的支付方式");
        return false;
      }
    },
    init: function() {
      this.yprice = this.viplist[0].yprice;
      this.price = this.viplist[0].price;
      console.log("调用页面初始");
    },
    chooseVip: function(item, num) {
      var vipObje = this.viplist[num];
      this.yprice = vipObje.yprice;
      this.price = vipObje.price;
      this.type = vipObje.type;
      for (var i = 0; i < this.viplist.length; i++) {
        var obje = this.viplist[i];
        obje.active = false;
      }
      if (item.active) {
        item.active = false;
      } else {
        item.active = true;
      }
      this.$point.eventId("h5_pay_100001");
    },
    comnitPay: function() {
      var viptype = this.getUserInfo.viptype;
      if(viptype == 3){
           tips.toast("您已经是永久VIP用户，无需购买");
          return;

      }  

      //判断是否是微信环境
     
      // if (this.paymethod == 6) {
      //   tips.toast("正在开发中,请您耐心等待");
      //   return false;
      // }

      //
      this.$point.eventId("h5_pay_100002");

         var val = 1;
        if (this.type == 1) {
          val = 1;
        } else if (this.type == 2) {
          val = 4;
        } else if (this.type == 3) {
          val = 5;
        } else if (this.type == 4) {
          val = 2;
        } else if (this.type == 5) {
          val = 3;
        }

        window.location.href = "hqml://applePay?key=payType&value=" + val;
        return;
      
    },
    initPayMethod() {
      var data = {};

      this.$axiosHttp({
        method: "POST",
        url: api.qml.init,
        data: data
      })
        .then(res => {
          var pay = res.result.app_pay_flag;
          if (pay == 1) {
            this.iosPay = true;
            //判断设备
            const u = navigator.userAgent;
            console.log(u);
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            console.log(" this.getAppFlag: "+this.getAppFlag )
            if (isiOS && this.getAppFlag == true) {
              this.isIOS = true;
              this.iosPay = false;

              this.paymethod = 99;
            } else {
              this.iosPay = false;
            }
          } else {
            this.iosPay = false;
          }
          console.log("iosPay:" + this.iosPay + " isiOS:" + this.isIOS);
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    }
  },
  
  components: {
    headBack
  }
};
</script>
<style  scoped>
#pay {
  width: 750px;
  height: auto;
  white-space: nowrap;
  overflow: hidden;
}

.titile {
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(24, 23, 35, 1);
  line-height: 50px;
  margin: 38px auto 26px;
}

.pay-back {
  height: 100px;
  width: 686px;
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(152, 87, 56, 1);
  line-height: 100px;
  background: url("../../assets/img/pay-back@2x.png");
  background-size: 100% 100%;
  margin: 0 auto;
}

.pay-title {
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(24, 23, 35, 1);
  line-height: 40px;
  text-align: left;
  padding: 24px 0 0 38px;
}

.pay-list {
  width: 100%;
  height: 580px;
  padding: 0px 34px 0 34px;
}

.pay-list-dive {
  width: 210px;
  height: 202px;
  margin-left: 24px;
  margin-top: 24px;
  float: left;
  background: #ffffff;
  border-radius: 6px;
  border: 2px solid rgba(237, 237, 237, 1);
}

.pay-list-dive:nth-child(3n-2) {
  margin-left: 0px;
}

.pay-simple {
  width: 100%;
  height: 182px;
  padding-top: 20px;
}

.paySimpleunclick {
  background: rgba(254, 249, 241, 1);
  border: 2px solid rgba(238, 204, 149, 1);
}

.pay-simple-name {
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
}
.pay-simple-money {
  font-size: 55px;
  font-family: DINCondensed-Bold, DINCondensed;
  font-weight: bold;
  color: rgba(169, 122, 95, 1);
  /* line-height: 90px; */
  display: inline-block;
  transform: scale(1, 1.3);
  text-indent: 26px;
}
.pay-simple-money::before {
  content: "￥";
  width: 26px;
  height: 48px;
  font-size: 34px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(169, 122, 95, 1);
  line-height: 58px;
  position: relative;
  text-align: center;
  margin: 10px 0 0 -40px;
}
.pay-simple-yuan {
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(153, 153, 157, 1);
  line-height: 40px;
  text-decoration: line-through;
}
.pay-simple-i::before {
  content: "￥";
  width: 12px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(119, 120, 125, 1);
  line-height: 28px;
  position: relative;
  text-align: center;
  margin: 6px 0 0 -20px;
  font-style: normal;
}

.pay-simple button {
  width: 144px;
  height: 40px;
  background: rgba(230, 188, 120, 1);
  border-radius: 20px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  border: none;
  display: block;
  margin: 10px auto 0px;
}
.pay-tui {
  width: 182px;
  height: 32px;
  background: linear-gradient(
    90deg,
    rgba(175, 176, 180, 1) 0%,
    rgba(58, 58, 57, 1) 100%
  );
  border-radius: 14px 14px 14px 4px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: rgba(239, 208, 157, 1);
  line-height: 32px;
  position: absolute;
  margin: -36px 0 0 0;
}

.unpay-div {
  width: 662px;
  height: 55px;
  padding: 48px 34px 0px 38px;
  text-align: left;
  display: flex;
}
.unpay-div-title {
  width: 150px;
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(24, 23, 35, 1);
  line-height: 40px;
}
.unpay-div-a-money {
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 40px;
  position: relative;
  margin-left: 12px;
  flex: 1;
  text-decoration: line-through;
}
.unpay-div-money {
  width: 270px;
  height: 66px;
  font-size: 48px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 0, 41, 1);
  line-height: 66px;
  text-align: right;
  position: relative;
  margin-left: 12px;
  margin-top: -12px;
}

.pay-agree {
  width: 100%;
  margin: 0 38px 0 38px;
  height: 34px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 34px;
  text-align: left;
}
.pay-agree-span {
  padding-left: 45px;
}

.pay-agree-span .check-mark {
  width: 28px;
  height: 28px;
  margin-top: 4px;
}

.pay-weixin,
.pay-alipay,
.pay-ios {
  width: 686px;
  height: 50px;
  padding: 0px 32px;
  margin-top: 50px;
}

.pay-weixin-content,
.pay-ios-content,
.pay-alipay-content {
  width: 300px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 50px;
  text-align: left;
  float: left;
}

.pay-weixin-content::before {
  background-image: url("../../assets/img/pay-weixin@2x.png");
  content: "";
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 2px;
  vertical-align: middle;
  background-size: 100%;
  margin: -7px 20px 0px 0px;
}
.pay-alipay-content::before {
  background-image: url("../../assets/img/pay-alipay@2x.png");
  content: "";
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 2px;
  vertical-align: middle;
  background-size: 100%;
  margin: 0px 20px 0px 0px;
}

.pay-ios-content::before {
  background-image: url("../../assets/img/ios-pay.png");
  content: "";
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 2px;
  vertical-align: middle;
  background-size: 100%;
  margin: 0px 20px 0px 0px;
}

.pay-weixin-lable,
.pay-alipay-lable {
  float: right;
  margin-right: 60px;
  margin-top: 6px;
}

.pay-weixin-lable .check-mark,
.pay-alipay-lable .check-mark {
  width: 44px;
  height: 44px;
}

.vip-button {
  width: 632px;
  height: 92px;
  background: linear-gradient(
    90deg,
    rgba(108, 103, 253, 1) 0%,
    rgba(28, 97, 235, 1) 100%
  );
  border-radius: 50px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 92px;
  margin: 56px auto 80px;
}

/* checkbox circle / Card Left */
.checkbox {
  display: none;
}
.label {
  position: relative;
  display: block;
  user-select: none;
}
.check-mark {
  width: 30px;
  height: 30px;
  background-color: #ffffff;
  position: absolute;
  left: 0;
  display: inline-block;
  top: 0;
  border: 2px solid #dad9dc;
  border-radius: 50%;
}
.label .checkbox:checked + .check-mark {
  background-color: #2f5ae8;
  transition: 0.1s;
}
.label .checkbox:checked + .check-mark:after {
  content: "";
  position: absolute;
  width: 10px;
  transition: 0.1s;
  height: 5px;
  background: #2f5ae8;
  top: 45%;
  left: 50%;
  border-left: 2px solid #dad9dc;
  border-bottom: 2px solid #dad9dc;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.pay-check {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  margin: 3px 28px 0px 108px;
  position: relative;
  float: left;
  overflow: hidden;
  border: 2px solid #dad9dc;
  float: right;
}

.pay-checked {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  margin: 3px 28px 0px 108px;
  position: relative;
  float: left;
  overflow: hidden;
  background: url("../../assets/img/pay-checked.png");
  background-size: 100% 100%;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/page/payApple.vue